import http from '../http'
import decode from 'jwt-decode'
import stringHash from 'string-hash'
import router from '@/router'

export default {
    namespaced: true,
    state: {
        relogged: false,
        reloggedName: null,
        team: 'Alle teams',
        teams: [],
        token: null,
        access: null,
        users: null,
        userMap: null,
        campaigns: null,
        campaignMap: null,
        name: null,
        orgCode: null,
        uniqueId: null,
        department: null,
        levelColors: ['lightcoral', 'orange', 'purple', 'navy', 'green'],
        standardSalesPivotOptions: {
            fields: [
                {
                    header: 'Afsl.',
                    field: 'count',
                    cols: '2',
                    formatter: v => v != 'Infinity' ? Math.round(v ? v : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0,
                },
                {
                    header: 'Salg',
                    field: 'sales',
                    cols: '1',
                    formatter: v => v != 'Infinity' ? Math.round(v ? v : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0,
                },
                {
                    header: 'HR',
                    field: 'hitrate',
                    cols: '1',
                    formatter: v => v != 'Infinity' ? Math.round(v * 100) + '%' : 0
                },
                {
                    header: 'BP/LF',
                    field: 'carService',
                    cols: '1',
                    formatter: v => v != 'Infinity' ? Math.round(v ? v : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0,
                },
                {
                    header: 'Solgt præmie',
                    field: 'total',
                    cols: '2',
                    formatter: v => v != 'Infinity' ? Math.round(v ? v : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0,
                },
                {
                    header: 'Gns. præmie',
                    field: 'avgSale',
                    cols: '2',
                    formatter: v => v != 'Infinity' ? Math.round(v ? v : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0,
                },
                {
                    header: 'Salg pr. emne',
                    field: 'avgLead',
                    cols: '2',
                    formatter: v => v != 'Infinity' ? Math.round(v ? v : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : 0,
                }
            ],
            valueFunctions: {
                'count': v => v.count,
                'sales': v => v.sales,
                'hitrate': v => v.count ? v.sales / v.count : !!v.sales * 1,
                'carService': v => v.carService,
                'total': v => v.total,
                'avgSale': v => v.sales ? v.total / v.sales : v.total,
                'avgLead': v => v.count ? v.total / v.count : v.total
            },
            nestedFields: ['count', 'sales', 'carService', 'total']
        }
    },
    getters: {
        getUsers: state => team => {
            if (state.users) {
                if (team === 'Alle teams') {
                    return state.users
                } else if (team === 'Tryg') {
                    return state.users.filter(user => user.department === 'tryg')
                } else if (team === 'Alka') {
                    return state.users.filter(user => user.department === 'alka')
                }
                else {
                    return state.users.filter(user => user.team === team)
                }
            } else {
                return []
            }
        },
        getCampaigns: state => {
            if (state.campaigns) return state.campaigns
            else return []
        },
        getAccess: state => state.access
    },
    actions: {
        async getConfig({ state, dispatch }) {
            if (state.access === 'fh' || state.access === 'pii') return null
            try {
                const response = await http().get('/config')
                state.campaigns = response.data.campaigns
                state.campaignMap = response.data.campaigns.reduce((map, campaign) => {
                    map[campaign.uniqueId] = campaign.name
                    return map
                }, {})
                state.users = response.data.users
                state.userMap = response.data.users.reduce((map, user) => {
                    map[user.orgCode] = user.name
                    return map
                }, {})
                state.teams =['Alle teams', 'Tryg', 'Alka', ...response.data.teams.map(team => team.name)]
            } catch ( {response} ) {
                if (response.status === 401) {
                    dispatch('logout')
                    router.push({ path: '/login' });
                }
            }
        },
        async login({ commit }, { hbLogin, username, password }) {
            let login
            try {
                login = await http().post('/login', {
                    username: username,
                    password: hbLogin ? password : stringHash(password),
                    hbLogin: hbLogin
                })
            } catch (e) {
                return false
            }
            if (login.status === 200) {
                commit('setToken', login.data)
                commit('setAccess', decode(login.data).access)
                commit('setOrgCode', decode(login.data).orgCode)
                commit('setUniqueId', decode(login.data).uniqueId)
                commit('setDepartment', decode(login.data).department)
                commit('setName', decode(login.data).name)
                return true
            } else return false
        },
        logout({ commit }) {
            commit('setToken', null)
            commit('setAccess', null)
            commit('setOrgCode', null)
            commit('setUniqueId', null)
            commit('setDepartment', null)
            commit('setName', null)
            commit('setRelogged', false)
        },
        relog ({ commit }, user) {
            commit('setReloggedName', user.name)
            commit('setAccess', 'tele')
            commit('setUniqueId', user.uniqueId)
            commit('setDepartment', user.department)
            commit('setRelogged', true)
        },
        reLogout({ state, commit }) {
            commit('setReloggedName', null)
            commit('setAccess', decode(state.token).access)
            commit('setOrgCode', null)
            commit('setUniqueId', null)
            commit('setDepartment', null)
            commit('setRelogged', false)
        }
    },
    mutations: {
        setDepartment: (state, department) => {
            state.department = department
            department ? localStorage.setItem('department', department) : localStorage.removeItem('department')
        },
        setToken: (state, token) => {
            state.token = token
            token ? localStorage.setItem('token', token) : localStorage.removeItem('token')
        },
        setAccess: (state, access) => {
            state.access = access
            access ? localStorage.setItem('access', access) : localStorage.removeItem('access')
        },
        setOrgCode: (state, orgCode) => {
            state.orgCode = orgCode
            orgCode ? localStorage.setItem('orgCode', orgCode) : localStorage.removeItem('orgCode')
        },
        setUniqueId: (state, uniqueId) => {
            state.uniqueId = uniqueId
            uniqueId ? localStorage.setItem('uniqueId', uniqueId) : localStorage.removeItem('uniqueId')
        },
        setName: (state, name) => {
            state.name = name
            name ? localStorage.setItem('name', name) : localStorage.removeItem('name')
        },
        setRelogged: (state, relogged) => {
            state.relogged = relogged
            relogged ? localStorage.setItem('relogged', relogged) : localStorage.removeItem('relogged')
        },
        setReloggedName: (state, reloggedName) => {
            state.reloggedName = reloggedName
            reloggedName ? localStorage.setItem('reloggedName', reloggedName) : localStorage.removeItem('reloggedName')
        },
        setTeam: (state, team) => {
            state.team = team
        }
    }
}